module.exports = __webpack_public_path__ + "img/8.d141f7b2.png";